document.addEventListener("DOMContentLoaded", function () {

    const images = document.querySelectorAll(".harzo-lightbox");

    if (images.length === 0)
        return;

    const overlay = document.createElement("div");
    overlay.id = "harzo-lightbox";

    overlay.innerHTML = `
        <span class="close">&times;</span>
        <img>
    `;

    document.body.appendChild(overlay);

    const overlayImage = overlay.querySelector("img");
    const close = overlay.querySelector(".close");

    images.forEach(img => {

        img.style.cursor = "zoom-in";

        img.addEventListener("click", function () {

            overlayImage.src = this.src;
            overlayImage.alt = this.alt;

            overlay.classList.add("show");

        });

    });

    close.addEventListener("click", function () {

        overlay.classList.remove("show");

    });

    overlay.addEventListener("click", function (e) {

        if (e.target === overlay)
            overlay.classList.remove("show");

    });

    document.addEventListener("keydown", function (e) {

        if (e.key === "Escape")
            overlay.classList.remove("show");

    });

});